export const INFERENCE_FILE_TYPES = {
  WAV_MIME_TYPES: ['audio/wav', 'audio/x-wav', 'audio/wave', 'audio/x-pn-wav'],
  MP3_MIME_TYPES: ['audio/mpeg', 'audio/mp3', 'audio/x-mpeg', 'audio/x-mp3', 'audio/x-mpeg-3'],
  FLAC_MIME_TYPES: ['audio/flac']
}

export const INFERENCE_MAX_FILE_SIZE_MB = 100
export const LOGGED_OUT_MAX_FILE_SIZE_MB = 20

export const INFERENCE_MAX_FILES_COUNT = 5

export const INFERENCE_QUALITY_VALUES = ['quick', 'detailed']

export const STEM_SPLITTER_FILE_TYPES = {
  WAV_MIME_TYPES: INFERENCE_FILE_TYPES.WAV_MIME_TYPES,
  MP3_MIME_TYPES: INFERENCE_FILE_TYPES.MP3_MIME_TYPES,
  FLAC_MIME_TYPES: INFERENCE_FILE_TYPES.FLAC_MIME_TYPES
}

export const MASTERING_FILE_TYPES = {
  WAV_MIME_TYPES: INFERENCE_FILE_TYPES.WAV_MIME_TYPES,
  MP3_MIME_TYPES: INFERENCE_FILE_TYPES.MP3_MIME_TYPES,
  FLAC_MIME_TYPES: INFERENCE_FILE_TYPES.FLAC_MIME_TYPES
}

export const EXTENSION_TO_MIME_TYPE = {
  wav: INFERENCE_FILE_TYPES.WAV_MIME_TYPES[0],
  mp3: INFERENCE_FILE_TYPES.MP3_MIME_TYPES[0],
  flac: INFERENCE_FILE_TYPES.FLAC_MIME_TYPES[0]
}

export const mimetypeToExtension = (mimeType: string) => {
  for (const [key, mimeTypes] of Object.entries(INFERENCE_FILE_TYPES)) {
    const processedKey = key.toLowerCase().split('_')[0]
    if (mimeTypes.includes(mimeType)) return processedKey
  }
  return undefined
}

export const ALL_INFERENCE_FILE_TYPES: string[] = Object.keys(INFERENCE_FILE_TYPES).flatMap(
  (key) => INFERENCE_FILE_TYPES[key]
)

export const ALL_STEM_SPLITTER_FILE_TYPES: string[] = Object.keys(STEM_SPLITTER_FILE_TYPES).flatMap(
  (key) => MASTERING_FILE_TYPES[key]
)

export const ALL_MASTERING_FILE_TYPES: string[] = Object.keys(MASTERING_FILE_TYPES).flatMap(
  (key) => MASTERING_FILE_TYPES[key]
)

export const ALL_AUDIO_PROCESSING_FILE_TYPES: string[] = Object.keys(MASTERING_FILE_TYPES).flatMap(
  (key) => MASTERING_FILE_TYPES[key]
)

export const MAX_INFERENCE_DURATION_MIN = 10
